const basic = new Set('@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !"#¤%&\'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà');
const extended = new Set('^{}\\[~]|€\f');
const turkish = new Set('ĞğŞşİıç');

// iletiMerkezi appends B186. Limits assume the matching language mode is enabled
// in the provider's account; the final charge is determined by the provider.
export function estimateSms(text: string) {
  let units = 0;
  let mode: 'GSM-7' | 'Türkçe' | 'Unicode' = 'GSM-7';
  for (const character of text) {
    if (extended.has(character)) units += 2;
    else if (basic.has(character)) units++;
    else if (turkish.has(character)) { units++; mode = 'Türkçe'; }
    else { mode = 'Unicode'; units = text.length; break; }
  }
  const first = mode === 'Unicode' ? 65 : mode === 'Türkçe' ? 150 : 155;
  const multipart = mode === 'Unicode' ? 63 : mode === 'Türkçe' ? 148 : 153;
  return { mode, units, parts: units === 0 ? 0 : units <= first ? 1 : Math.ceil(units / multipart) };
}

export function explainSmsFailure(code: string, balance?: { amount: number; sms: number | null } | null) {
  if (code !== '402') return '';
  const current = balance ? ` Entegrasyonun gördüğü bakiye: ${balance.amount.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} TL${balance.sms !== null ? `, yaklaşık ${balance.sms.toLocaleString('tr-TR')} standart SMS` : ''}.` : '';
  return `İleti Merkezi 402 (bakiye yetersiz) yanıtı verdi.${current} Paneldeki TL bakiyesi ile aynı API hesabının kullanılabilir SMS kredisi karşılaştırılmalıdır. Bakiyeler farklıysa canlı sunucudaki API anahtarı/hash başka veya eski bir hesaba ait olabilir. Bakiyeler aynı ve yeterliyse sağlayıcının hesap/ücretlendirme ayarlarını kontrol ettirin. Mesaj uzunluğu ve dil modu her alıcının kredi tüketimini artırır.`;
}
